import type { AppComboBoxUnionProps } from "./AppComboBox.Props";
import { controlStylingConstants } from "@1js/acui-common";
/**
 * Key for custom/freeform input option
 */
export const customOptionKey = "acui-combobox-custom-option";

/**
 * Styling constants
 */
export const comboboxOptionHeight = "32px";
export const comboboxOptionHeightWithSubText = "50px";

/**
 * Returns the width offset of a specific ComboBox. This offset is due to negative margin when pinning two
 * adjacent ComboBoxes
 */
export function getComboBoxControlWidthOffset(
  controlProps: AppComboBoxUnionProps,
  adjacentControlProps?: AppComboBoxUnionProps
) {
  const { comboBoxRightMargin, comboBoxBorderWidth } = controlStylingConstants;
  const pinnedComboBoxStylingOffset = comboBoxRightMargin + comboBoxBorderWidth;
  let offset = 0;
  /* If this ComboBox is pinned, removing it will save the containerWidth plus its negative margin */
  if (controlProps?.pinToPreviousComboBox) {
    offset += pinnedComboBoxStylingOffset;
  }
  /* If the next ComboBox is pinned to this one, removing this ComboBox will save the containerWidth minus its negative margin */
  if (adjacentControlProps?.pinToPreviousComboBox) {
    offset -= pinnedComboBoxStylingOffset;
  }
  return Math.ceil(offset);
}
